import {
  companionLbAdSlotSizesInfinteScroll,
  pubPageAdTargeting,
} from "@config/AdsConstants";
import CompanionAdvertisement from "@elements/Advertisement/CompanionAdvertisement";
import { GoogleAdsSlotFactory } from "@elements/Advertisement/helpers";
import {
  AdTargetingType,
  AdvertisementTypeEnum,
  ArticleAdSlotTargetingType,
  PageAdTargetValue,
} from "@typings/Ads.d";
import { CSSProperties } from "react";
import { twMerge } from "tailwind-merge";

/**
 * Tabla Companion Lb Ad
 * Description: The Companion Lb component for rendering ads.
 * @name - name of section or page
 * @index - use when lb1 is rendered more than 1
 */
export function CompanionAdsLb({
  adType = AdvertisementTypeEnum.LB1,
  uniqueSectionName,
  index,
  pageAdTargetType,
  articleSlotTarget,
  rootClassName,
  rootStyle,
}: {
  adType?: AdvertisementTypeEnum;
  uniqueSectionName: string;
  index: number;
  pageAdTargetType: PageAdTargetValue;
  articleSlotTarget?: ArticleAdSlotTargetingType[];
  rootClassName?: string;
  rootStyle?: CSSProperties | undefined;
}) {
  let overrideLbSlot = companionLbAdSlotSizesInfinteScroll[adType]?.desktop;
  if (typeof window !== "undefined" && screen.width < 767) {
    overrideLbSlot = companionLbAdSlotSizesInfinteScroll[adType]?.mobile;
  }

  const pageAdTarget = pubPageAdTargeting[
    pageAdTargetType
  ] as AdTargetingType<PageAdTargetValue>;
  return (
    <div
      className={twMerge("justify-items-center w-full", rootClassName)}
      style={rootStyle}
    >
      <CompanionAdvertisement
        companionAdUnitProps={{
          type: adType,
          slot: GoogleAdsSlotFactory(adType, uniqueSectionName),
          id: `dfp-ad-${adType}-${index}`,
          rootClassName: "m-0 w-fit mx-auto",
          adSlotSize: overrideLbSlot,
          pageNumber: index.toString(),
          pubAdTargeting: [pageAdTarget],
          articleSlotTarget,
        }}
      />
    </div>
  );
}
